/**
 * Damage claims domain API (deposit subsystem Phase 3b).
 *
 * Tenancy-level 1:N damage-claim CRUD. JSON bodies (not FormData). Mirrors the
 * tenancy-document fns' list/create/delete shape, plus patch.
 */
import {
  API_BASE_URL,
  getApiHeaders,
  parseAdminErrorResponse,
} from "./core";

export function fetchAdminDamageClaims(tenancyId) {
  return fetch(
    `${API_BASE_URL}/api/admin/damage-claims?tenancy_id=${encodeURIComponent(tenancyId)}`,
    { headers: getApiHeaders() }
  )
    .then((res) => {
      if (!res.ok) throw new Error("Schadenfälle konnten nicht geladen werden.");
      return res.json();
    })
    .then((data) => {
      if (data != null && typeof data === "object" && Array.isArray(data.items)) {
        return data.items;
      }
      throw new Error('Ungültige Antwort: erwartet { items: [] }.');
    });
}

export async function createAdminDamageClaim(tenancyId, body) {
  const res = await fetch(`${API_BASE_URL}/api/admin/damage-claims`, {
    method: "POST",
    headers: getApiHeaders(),
    body: JSON.stringify({ ...body, tenancy_id: tenancyId }),
  });
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}

export async function patchAdminDamageClaim(claimId, body) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/damage-claims/${encodeURIComponent(claimId)}`,
    {
      method: "PATCH",
      headers: getApiHeaders(),
      body: JSON.stringify(body),
    }
  );
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}

export async function deleteAdminDamageClaim(claimId) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/damage-claims/${encodeURIComponent(claimId)}`,
    { method: "DELETE", headers: getApiHeaders() }
  );
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}
